<!-- Privremeno; kasnije promijeniti akciju za otvaranje agent_item view-a tako da, umjesto ui_component = openNestedViewAction, bude agentItemView ? -->
<app-oib-service-panel></app-oib-service-panel>
<h3 class="dialog-title">{{ titleChecked$ | async }}</h3>
<ng-container *ngIf="view$ | async as view; else noItemData">
  <ng-container ntapViewItemProvider>
    <!-- ovo iz nekog razloga mora bit ovdje, inace puca inicijalizacija jer se prerano okine setItem-->
    <ng-container *ngIf="detailViews$ | async as detailViews">
      <p-tabView (onChange)="changeTab($event)" [activeIndex]="activeTab" [style]="{ height: '100%' }">
        <!-- Tabs -->
        <p-tabPanel *ngFor="
            let accordionTab of attrTabsAccordionsTree
              | keyvalue:keepCategoryOrder;
            let tabIndex = index
          " [selected]="tabIndex === activeTab" header="{{ getCategoryLabel(accordionTab.key) }}">
          <!-- Body -->
          <ng-container *ngIf="
              accordionTab.value.length > 1 ||
                (accordionTab.value.length === 1 &&
                  accordionTab.value[0] !== accordionTab.key);
              else removeTabsIfOnlyOneChild
            ">
            <p-accordion [multiple]="true">
              <p-accordionTab *ngFor="
                  let accordionElement of accordionTab.value;
                  let i = index
                " header="{{ getSubcategoryLabel(accordionElement) }}" [selected]="
                  i === 0 || hasRequiredAttrs(accordionElement, view.attributes)
                ">
                <ntap-prime-property-pane [inputs]="inputs$" [accordionElement]="accordionElement"
                  [accordionTab]="accordionTab"></ntap-prime-property-pane>
              </p-accordionTab>
            </p-accordion>
          </ng-container>
          <ng-template #removeTabsIfOnlyOneChild>
            <div *ngFor="let accordionElement of accordionTab.value; let i = index">
              <ntap-prime-property-pane [inputs]="inputs$" [accordionElement]="accordionElement"
                [accordionTab]="accordionTab"></ntap-prime-property-pane>
            </div>
          </ng-template>
          <ng-container *ngIf="getCategoryComponent(accordionTab.key)">
            <ntap-dynamic [compId]="getCategoryComponent(accordionTab.key)"></ntap-dynamic>
          </ng-container>

          <ng-container *ngIf="
              activeTab === tabIndex &&
              matchDetailViewsToCategories(
                detailViews,
                accordionTab
              ) as matchingDetailViews
            ">
            <ng-container *ngIf="
                matchingDetailViews.length > 0 &&
                matchingDetailViews[0] as detailView
              ">
              <ng-container *ngIf="detailView.isItemView" ntapItemViewProvider [viewName]="detailView.viewName"
                [viewState]="detailView.viewState">
                <ntap-dynamic [compId]="detailView.compId!"></ntap-dynamic>
              </ng-container>
              <ng-container *ngIf="!detailView.isItemView" ntapListViewProvider [viewName]="detailView.viewName"
                [viewState]="detailView.viewState">
                <ng-container ntapFilterViewProvider #ntapFilterViewProvider [viewName]="detailView.viewName"
                  [viewState]="{}">
                  <ntap-dynamic [compId]="detailView.compId!"></ntap-dynamic>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </p-tabPanel>

        <p-tabPanel *ngFor="
            let detailView of nonMatching(detailViews);
            let tabIndex = index
          " [header]="detailView.title" [disabled]="detailView.isMasterItemNew">
            <ng-container *ngIf="(activeTab === attrTabsAccordionsTree.size + tabIndex) && !detailView.isMasterItemNew">
              <ng-container *ngIf="detailView.isItemView" ntapItemViewProvider [viewName]="detailView.viewName"
                [viewState]="detailView.viewState">
                <ntap-dynamic [compId]="detailView.compId!"></ntap-dynamic>
              </ng-container>
              <ng-container *ngIf="!detailView.isItemView" ntapListViewProvider [viewName]="detailView.viewName"
                [viewState]="detailView.viewState">
                <ng-container ntapFilterViewProvider #ntapFilterViewProvider [viewName]="detailView.viewName"
                  [viewState]="{}">
                  <ntap-dynamic [compId]="detailView.compId!"></ntap-dynamic>
                </ng-container>
              </ng-container>
          </ng-container>
        </p-tabPanel>
      </p-tabView>
      <p-footer>
        <ng-container *ngIf="hideFooter; else customActionBar"> </ng-container>
        <ng-template #customActionBar>
          <ng-container *ngIf="
              !!view.actions && view.actions.length > 0;
              else defaultActionBar
            ">
            <p-toolbar>
              <div class="ui-toolbar-group-right">
                <ntap-prime-actionbar></ntap-prime-actionbar>
              </div>
            </p-toolbar>
          </ng-container>
        </ng-template>
        <ng-template #defaultActionBar>
          <ng-container *ngIf="!!!view.name || view.name === '$defaultItemView'">
            <p-toolbar>
              <div class="ui-toolbar-group-right">
                <ntap-prime-action-close-item></ntap-prime-action-close-item>
              </div>
            </p-toolbar>
          </ng-container>
        </ng-template>
      </p-footer>
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #noItemData>
  <ng-container *ngIf="loadingState$ | async">
    <p-tabView [style]="{ height: '100%' }">
      <p-tabPanel [selected]="true">
        <p-accordion>
          <p-accordionTab [selected]="true">
            <p-skeleton></p-skeleton>
            <br />
            <p-skeleton></p-skeleton>
            <br />
            <p-skeleton></p-skeleton>
            <br />
            <p-skeleton></p-skeleton>
            <br />
          </p-accordionTab>
        </p-accordion>
      </p-tabPanel>
    </p-tabView>
  </ng-container>
</ng-template>